import React from 'react';

import styles from './SortArrow.module.scss';

export const SortArrow = () => (
  <svg
    className={styles['icon-sort-arrow']}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />
  </svg>
);
